const buildingBaseUrl = '/Building';

export default {
    getBuildingUrl: () => `${buildingBaseUrl}`,
    getAllBuildingsUrl: () => `${buildingBaseUrl}/all`,
    getBuildingByCityIdUrl: (cityId) => `${buildingBaseUrl}/byCityId?CityId=${cityId}`,
    getBuildingByIdUrl: (buildingId) => `${buildingBaseUrl}/byId?BuildingId=${buildingId}`,
};
